import { Component } from '@angular/core';
import { ModalPopupService } from './modal-popup.service';

@Component({
    selector: 'popupmodal',
    template: `
    <div #content>
    <h1 class="section-header">Confirm Navigation</h1>
    <div class="modal-body">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <p>You have unsaved changes that will be lost if you decide to continue.</p>
            <p>Are you sure you want to leave this page?</p>
          </div>
        </div>
      </div>
    </div>
   <div class="modal-footer justify-content-center">
    <button type="button" class="btn btn-outline-primary"  (click)="stayOnPage()">Stay on this Page</button>
    <button type="button" class="btn btn-primary" (click)="leavePage()">Leave this Page</button>
   </div>
   </div>`
})
export class ModalPopUp {
    constructor(
      private modalService: ModalPopupService
    ) {
    }

    stayOnPage() {
      this.modalService.stayOnPage();
    }

    leavePage() {
      this.modalService.leavePage();
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-popup/modal-popup.ts